export type RetrievedResult = {
  deeplink: string | null;
};

export const EVENT = 'onRetrieved';
